import React from 'react';
import { Form, FormControlProps, InputGroup } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import styled from 'styled-components';

type TextInputProps = FormControlProps & {
  label?: string;
  prefix?: string;
  error?: string;
};

export const TextInput = React.forwardRef<FormControlProps, TextInputProps>(
  ({ label, prefix, error, className, ...props }: TextInputProps, ref) => (
    <Form.Group>
      {label && <Form.Label className="text-16px">{label}</Form.Label>}

      <InputGroup>
        {prefix && <InputGroup.Text id="basic-addon1">{prefix}</InputGroup.Text>}

        <FormControl
          className={`${error && 'border border-danger'} ${className}`}
          ref={ref}
          type="text"
          {...props}
        />
      </InputGroup>

      {error && (
        <Form.Text className="text-danger">
          <Trans>{error}</Trans>
        </Form.Text>
      )}
    </Form.Group>
  ),
);

TextInput.displayName = `TextInput`;

const FormControl = styled(Form.Control)`
  height: 48px;
  align-items: end;
  vertical-align: bottom;
  border: ${(props) => (props.disabled ? `none` : `1px solid #b1b1b1`)};
  background-color: ${(props) => (props.disabled ? `#F2F2F2` : `white`)} !important;
`;